export const SET_PRODUCT = 'SET_PRODUCT';
export const SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN';
export const SET_SELECTED = 'SET_SELECTED';
export const SET_SELECTED_EPISODE_NUMBER = 'SET_SELECTED_EPISODE_NUMBER';
export const SET_VOD_ONLY_IN_PACKET = 'SET_VOD_ONLY_IN_PACKET';
export const SET_IS_PACKET_MODAL_OPEN = 'SET_IS_PACKET_MODAL_OPEN';
